// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS for the accessible modal dialogs created by dialog.ts */
/* dialog host */
#profile-modal {
  margin: 0;
  padding: 0;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  max-width: none;
  max-height: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  z-index: 9999;
}

#profile-modal:not([open]) {
  display: none;
}

#profile-modal::backdrop {
  background: rgba(0, 0, 0, 0.5);
}

#profile-modal .modal {
  box-sizing: border-box;
  margin: 0;
  background: var(--color-background);
  padding: var(--spacing-lg);
  border-radius: var(--border-radius-base);
  max-width: 100%;
  width: min(640px, 92vw);
  max-height: 85vh;
  overflow: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

#profile-modal .modal .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-lg);
  margin: calc(-1 * var(--spacing-lg)) calc(-1 * var(--spacing-lg)) var(--spacing-sm) calc(-1 * var(--spacing-lg));
  padding: var(--spacing-lg);
  border-radius: var(--border-radius-base, 0.3125rem) var(--border-radius-base, 0.3125rem) 0 0;
  border: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);
  background: var(--slate-50, #F8FAFC);
}

#profile-modal .modal #modal-title {
  margin: 0;
}

#profile-modal .modal #modal-header-action > button[aria-label="Close dialog"] {
  min-height: 2rem;
  min-width: 2rem;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text);
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}

#profile-modal .modal #modal-header-action > button[aria-label="Close dialog"]:hover {
  color: var(--color-primary);
}

#profile-modal .modal #modal-header-action {
  display: flex;
  align-items: center;
}

#profile-modal .modal .modal__header-action-button {
  min-height: auto;
  padding: var(--spacing-xxs);
  border: none;
  background: none;
  color: var(--color-primary);
  font-weight: 500;
}

#profile-modal .modal .modal__header-action-button:hover {
  text-decoration: underline;
}

/* button container: center buttons horizontally (uses id in markup) */
#profile-modal #modal-buttons {
  display: flex;
  padding: 20px 0 20px 30px;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  align-self: stretch;
  border-top: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);
  background: var(--gray-50, #F9FAFB);
}

#profile-modal #modal-buttons button {
  width: 10.8rem;
}

#profile-modal .modal__error-section {
  margin-top: var(--spacing-sm);
}

#profile-modal .modal__error-section[hidden] {
  display: none !important;
}


/* buttons themselves use the shared btn-primary rules */
#profile-modal .modal button {
  min-height: var(--min-touch-target);
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--color-primary);
  border-radius: var(--border-radius-base);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--animation-duration) ease;
}

#profile-modal .modal button.btn-primary {
  background: var(--color-primary);
  color: var(--white, #FFF);
  font-size: var(--font-size-lg, 1.125rem); /* 18px */
  font-weight: var(--font-weight-bold, 600);
}

#profile-modal .modal button.btn-primary:hover {
  background: color-mix(in srgb, var(--color-primary) 90%, black);
  box-shadow: 0 2px 4px rgba(124, 77, 255, 0.2);
}

#profile-modal .modal button.btn-primary:active {
  box-shadow: 0 1px 2px rgba(124, 77, 255, 0.2);
}

#profile-modal .modal button:disabled {
  opacity: var(--opacity-disabled, 0.6);
  cursor: not-allowed;
  transform: none;
}

/* Keep text-style actions in section headers while preserving footer button styling. */
#profile-modal .modal .profile__section-header .profile__action-button {
  min-height: auto;
  padding: var(--spacing-xxs);
  border: none;
  background: none;
  color: var(--color-primary);
  font-weight: 500;
}

#profile-modal .modal .profile__section-header .profile__action-button:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  #profile-modal {
    padding-top: max(var(--spacing-sm), env(safe-area-inset-top));
    padding-right: var(--spacing-sm);
    padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));
    padding-left: var(--spacing-sm);
    place-items: center;
  }

  #profile-modal .modal {
    width: min(420px, calc(100% - 2 * var(--spacing-sm)));
    max-width: 420px;
    max-height: calc(100dvh - 2 * var(--spacing-sm));
    padding: var(--spacing-md);
    border-radius: calc(var(--border-radius-base) * 0.75);
    overscroll-behavior: contain;
    justify-self: center;
    align-self: center;
    margin: 0;
  }

  #profile-modal .modal .modal-header {
    gap: var(--spacing-md);
    margin: calc(-1 * var(--spacing-md)) calc(-1 * var(--spacing-md)) var(--spacing-sm) calc(-1 * var(--spacing-md));
    padding: var(--spacing-md);
  }

  #profile-modal #modal-buttons {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-sm, 0.938rem);
    padding: var(--spacing-md) 0 0;
    margin: var(--spacing-md) auto 0;
    box-sizing: border-box;
    width: 100%;
  }

  #profile-modal #modal-buttons button {
    flex: 0 0 auto;
    width: 10.8rem;
    min-width: 8.5rem;
    padding: var(--spacing-sm) var(--spacing-md);
    font-size: var(--font-size-md, 1rem);
  }

}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/dialog.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D,gBAAgB;AAChB;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,mCAAmC;EACnC,0BAA0B;EAC1B,wCAAwC;EACxC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gHAAgH;EAChH,0BAA0B;EAC1B,4FAA4F;EAC5F,sEAAsE;EACtE,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0EAA0E;EAC1E,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA,wDAAwD;AACxD;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,sCAAsC;EACtC,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,wCAAwC,EAAE,SAAS;EACnD,yCAAyC;AAC3C;;AAEA;EACE,+DAA+D;EAC/D,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uFAAuF;AACvF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,6DAA6D;IAC7D,gCAAgC;IAChC,mEAAmE;IACnE,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,qDAAqD;IACrD,gBAAgB;IAChB,gDAAgD;IAChD,0BAA0B;IAC1B,qDAAqD;IACrD,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,gHAAgH;IAChH,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,8BAA8B;IAC9B,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,4CAA4C;IAC5C,oCAAoC;EACtC;;AAEF","sourcesContent":["/* CSS for the accessible modal dialogs created by dialog.ts */\n/* dialog host */\n#profile-modal {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: rgba(0, 0, 0, 0.5);\n  max-width: none;\n  max-height: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: fixed;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  z-index: 9999;\n}\n\n#profile-modal:not([open]) {\n  display: none;\n}\n\n#profile-modal::backdrop {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n#profile-modal .modal {\n  box-sizing: border-box;\n  margin: 0;\n  background: var(--color-background);\n  padding: var(--spacing-lg);\n  border-radius: var(--border-radius-base);\n  max-width: 100%;\n  width: min(640px, 92vw);\n  max-height: 85vh;\n  overflow: auto;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n#profile-modal .modal .modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-lg);\n  margin: calc(-1 * var(--spacing-lg)) calc(-1 * var(--spacing-lg)) var(--spacing-sm) calc(-1 * var(--spacing-lg));\n  padding: var(--spacing-lg);\n  border-radius: var(--border-radius-base, 0.3125rem) var(--border-radius-base, 0.3125rem) 0 0;\n  border: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);\n  background: var(--slate-50, #F8FAFC);\n}\n\n#profile-modal .modal #modal-title {\n  margin: 0;\n}\n\n#profile-modal .modal #modal-header-action > button[aria-label=\"Close dialog\"] {\n  min-height: 2rem;\n  min-width: 2rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--color-text);\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n#profile-modal .modal #modal-header-action > button[aria-label=\"Close dialog\"]:hover {\n  color: var(--color-primary);\n}\n\n#profile-modal .modal #modal-header-action {\n  display: flex;\n  align-items: center;\n}\n\n#profile-modal .modal .modal__header-action-button {\n  min-height: auto;\n  padding: var(--spacing-xxs);\n  border: none;\n  background: none;\n  color: var(--color-primary);\n  font-weight: 500;\n}\n\n#profile-modal .modal .modal__header-action-button:hover {\n  text-decoration: underline;\n}\n\n/* button container: center buttons horizontally (uses id in markup) */\n#profile-modal #modal-buttons {\n  display: flex;\n  padding: 20px 0 20px 30px;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 15px;\n  align-self: stretch;\n  border-top: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);\n  background: var(--gray-50, #F9FAFB);\n}\n\n#profile-modal #modal-buttons button {\n  width: 10.8rem;\n}\n\n#profile-modal .modal__error-section {\n  margin-top: var(--spacing-sm);\n}\n\n#profile-modal .modal__error-section[hidden] {\n  display: none !important;\n}\n\n\n/* buttons themselves use the shared btn-primary rules */\n#profile-modal .modal button {\n  min-height: var(--min-touch-target);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: 1px solid var(--color-primary);\n  border-radius: var(--border-radius-base);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--animation-duration) ease;\n}\n\n#profile-modal .modal button.btn-primary {\n  background: var(--color-primary);\n  color: var(--white, #FFF);\n  font-size: var(--font-size-lg, 1.125rem); /* 18px */\n  font-weight: var(--font-weight-bold, 600);\n}\n\n#profile-modal .modal button.btn-primary:hover {\n  background: color-mix(in srgb, var(--color-primary) 90%, black);\n  box-shadow: 0 2px 4px rgba(124, 77, 255, 0.2);\n}\n\n#profile-modal .modal button.btn-primary:active {\n  box-shadow: 0 1px 2px rgba(124, 77, 255, 0.2);\n}\n\n#profile-modal .modal button:disabled {\n  opacity: var(--opacity-disabled, 0.6);\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Keep text-style actions in section headers while preserving footer button styling. */\n#profile-modal .modal .profile__section-header .profile__action-button {\n  min-height: auto;\n  padding: var(--spacing-xxs);\n  border: none;\n  background: none;\n  color: var(--color-primary);\n  font-weight: 500;\n}\n\n#profile-modal .modal .profile__section-header .profile__action-button:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 640px) {\n  #profile-modal {\n    padding-top: max(var(--spacing-sm), env(safe-area-inset-top));\n    padding-right: var(--spacing-sm);\n    padding-bottom: max(var(--spacing-sm), env(safe-area-inset-bottom));\n    padding-left: var(--spacing-sm);\n    place-items: center;\n  }\n\n  #profile-modal .modal {\n    width: min(420px, calc(100% - 2 * var(--spacing-sm)));\n    max-width: 420px;\n    max-height: calc(100dvh - 2 * var(--spacing-sm));\n    padding: var(--spacing-md);\n    border-radius: calc(var(--border-radius-base) * 0.75);\n    overscroll-behavior: contain;\n    justify-self: center;\n    align-self: center;\n    margin: 0;\n  }\n\n  #profile-modal .modal .modal-header {\n    gap: var(--spacing-md);\n    margin: calc(-1 * var(--spacing-md)) calc(-1 * var(--spacing-md)) var(--spacing-sm) calc(-1 * var(--spacing-md));\n    padding: var(--spacing-md);\n  }\n\n  #profile-modal #modal-buttons {\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: var(--spacing-sm, 0.938rem);\n    padding: var(--spacing-md) 0 0;\n    margin: var(--spacing-md) auto 0;\n    box-sizing: border-box;\n    width: 100%;\n  }\n\n  #profile-modal #modal-buttons button {\n    flex: 0 0 auto;\n    width: 10.8rem;\n    min-width: 8.5rem;\n    padding: var(--spacing-sm) var(--spacing-md);\n    font-size: var(--font-size-md, 1rem);\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
